import UserListCampaignsPage from '../../components/UserListCampaigns/UserListCampaignsPage';
const UserListCampaign = () => {

    return (
        <div>
            <UserListCampaignsPage />
        </div>
    );

};

export default UserListCampaign;
